import React from 'react'
import { string, array, object, bool } from 'prop-types'
import { EventArticleGridSnippet } from '@/component/Primitive/Events'
import createButtonGroup from '../lib/button-group-creator'
import changeFileExtension from '@/lib/filename-extension-modifier'

const EventArticleGridSnippetWidget = ({
  title,
  subtitle,
  theme,
  buttonGroup,
  articles,
  pageData,
  includeThumbnails
}) => {
  if (!articles || !articles.results || articles.results.length === 0)
    return null

  // Format articles for the component
  const formattedArticles = articles.results
    .slice(0, 5)
    .map((article, index) => {
      const imageCrop = 'landscape'

      const imageSizeMap = {
        landscape: [138, 206, 290, 412, 580, 900]
      }

      return {
        id: article._id,
        title: article.headline,
        description: article.sell,
        link: article.fullUrlPath,
        featured: article.featured || index === 0, // First article is always featured
        category: article._eventArticleCategoryName,
        attribution: article.attribution,
        subAttribution: article.subAttribution,
        ctaText: 'Read More',
        // eslint-disable-next-line camelcase
        src: article.images?.[`thumbnail_${imageCrop}_290`]?.[0]?.url,
        srcSet: imageSizeMap[imageCrop].map((size) => {
          return {
            width: size,
            src: changeFileExtension(
              article.images?.[`thumbnail_${imageCrop}_${size}`]?.[0]?.url,
              'webp'
            )
          }
        })
      }
    })

  return (
    <EventArticleGridSnippet
      title={title}
      subtitle={subtitle}
      theme={theme}
      buttonGroup={createButtonGroup(pageData, buttonGroup)}
      articles={formattedArticles}
      includeThumbnails={includeThumbnails}
    />
  )
}

EventArticleGridSnippetWidget.propTypes = {
  title: string,
  subtitle: string,
  theme: string,
  buttonGroup: array,
  articles: object,
  pageData: object,
  includeThumbnails: bool
}

EventArticleGridSnippetWidget.defaultProps = {
  includeThumbnails: true
}

export default EventArticleGridSnippetWidget
